import { trackGACustomEvent } from '../common'
import { GA_TRACK_CATEGORY } from '../constants'
import { IDrop } from '../interfaces/analyticsInterfaces'

const EVENT_REQUESTED_NEW_DROP = 'requested_new_drop'
const EVENT_SUCCESS_NEW_DROP = 'created_drop'
const EVENT_ACCEPT_COMPLETE_FORM = 'more_info_accept'
const EVENT_REJECT_COMPLETE_FORM = 'more_info_reject'
const EVENT_SEND_FORM = 'more_info_send'

export const Drop: IDrop = {
  trackClickSaveNewPoapButton: () => {},

  trackRequestCreateDrop: () => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.DROP,
      action: EVENT_REQUESTED_NEW_DROP,
    })
  },

  trackRequestedCreateDropSuccess: (eventId: number) => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.DROP,
      action: EVENT_SUCCESS_NEW_DROP,
    })
  },

  trackMoreInfoModal: (aceptForm: boolean) => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.DROP,
      action: aceptForm ? EVENT_ACCEPT_COMPLETE_FORM : EVENT_REJECT_COMPLETE_FORM,
    })
  },

  trackMoreInfoModalCompleteData: () => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.DROP,
      action: EVENT_SEND_FORM,
    })
  },
}
